module.exports = __webpack_public_path__ + "media/crypto/busd-0f72360c.png";